import graphQLAdapter from "@/adapters/graphQL.adapter.js";
import VariantCharacterGroup from "@/entities/variantCharacterGroup.entity.js";

/**
 * VariantCharacterGroup Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getVariantCharacterGroups = getVariantCharacterGroups.bind(this);
    this.getVariantCharacterGroup = getVariantCharacterGroup.bind(this);
    this.variantCharacterGroupCreate = variantCharacterGroupCreate.bind(this);
    this.variantCharacterGroupUpdate = variantCharacterGroupUpdate.bind(this);
    this.variantCharacterGroupDelete = variantCharacterGroupDelete.bind(this);
  }

  async list (options) {
    await this.adapter.init();

    // 「手書き」または「SK書体」を選択した場合、該当する文字画像が用意されていないため
    // 「機械書(合掌体)」の文字画像を表示するようにする
    // 「機械書手彫風書体」を選択した場合は「手彫り風書体」の文字画像を表示する
    if (
      options.q.font === "手書き" ||
      options.q.font === "SK書体"
    ) {
      options.q.font = "合掌体";
    } else if (options.q.font === "機械書手彫風書体") {
      options.q.font = "手彫り風書体";
    }

    const res = await this.getVariantCharacterGroups(options);

    return !res.data.variantCharacterGroups
      ? res.data.variantCharacterGroups
      : res.data.variantCharacterGroups.map(item => {
        return VariantCharacterGroup.fromJson(item);
      });
  }
  async get (options) {
    await this.adapter.init();
    const res = await this.getVariantCharacterGroup(options);
    return res.data.variantCharacterGroup === null
      ? res.data.variantCharacterGroup
      : VariantCharacterGroup.fromJson(res.data.variantCharacterGroup);
  }
  async create (options) {
    await this.adapter.init();
    const res = await this.variantCharacterGroupCreate(options);
    return !res.data.variantCharacterGroupCreate
      ? res.data.variantCharacterGroupCreate
      : VariantCharacterGroup.fromJson(res.data.variantCharacterGroupCreate);
  }
  async update (options) {
    await this.adapter.init();
    const res = await this.variantCharacterGroupUpdate(options);
    return !res.data.variantCharacterGroupUpdate
      ? res.data.variantCharacterGroupUpdate
      : VariantCharacterGroup.fromJson(res.data.variantCharacterGroupUpdate);
  }
  async delete (options) {
    await this.adapter.init();
    const res = await this.variantCharacterGroupDelete(options);
    return !res.data.variantCharacterGroupDelete
      ? res.data.variantCharacterGroupDelete
      : VariantCharacterGroup.fromJson(res.data.variantCharacterGroupDelete);
  }
}

function getVariantCharacterGroups (options = {}) {
  const query = `
    query ($q: VariantCharacterGroupFilterConditions) {
      variantCharacterGroups(q: $q) {
        id
        font
        code
        searchConditions
        variantCharacters {
          id
          imageUrl
          imageUrlForTablet
          managementCode1
          managementCode2
          inputCode
          sortNumber
        }
      }
    }
  `;
  return this.adapter.query(query, options);
}

function getVariantCharacterGroup (options = {}) {
  const query = `
    query ($id: ID!) {
      variantCharacterGroup(variantCharacterGroupId: $id) {
        id
        font
        code
        searchConditions
        variantCharacters {
          id
          imageUrl
          imageUrlForTablet
          managementCode1
          managementCode2
          inputCode
          sortNumber
        }
      }
    }
  `;
  return this.adapter.query(query, options);
}

function variantCharacterGroupCreate (options = {}) {
  const mutation = `
    mutation ($input: VariantCharacterGroupInput!) {
      variantCharacterGroupCreate(variantCharacterGroup: $input) {
        id
        font
        code
        searchConditions
        variantCharacters {
          id
          imageUrl
          imageUrlForTablet
          managementCode1
          managementCode2
          inputCode
          sortNumber
        }
      }
    }
  `;
  return this.adapter.mutation(mutation, options);
}

function variantCharacterGroupUpdate (options = {}) {
  const mutation = `
    mutation ($id: ID!, $input: VariantCharacterGroupInput!){
      variantCharacterGroupUpdate(variantCharacterGroupId: $id, variantCharacterGroup: $input){
        id
        font
        code
        searchConditions
        variantCharacters {
          id
          imageUrl
          imageUrlForTablet
          managementCode1
          managementCode2
          inputCode
          sortNumber
        }
      }
    }
  `;
  return this.adapter.mutation(mutation, options);
}

function variantCharacterGroupDelete (options = {}) {
  const mutation = `
    mutation ($id: ID!) {
      variantCharacterGroupDelete(variantCharacterGroupId: $id) {
        id
        font
        code
        searchConditions
        variantCharacters {
          id
          imageUrl
          imageUrlForTablet
          managementCode1
          managementCode2
          inputCode
          sortNumber
        }
      }
    }
  `;
  return this.adapter.mutation(mutation, options);
}
